import React, { Component } from 'react';
import Highcharts from 'highcharts';
 
class AdherencePercentBarChart extends Component {
  componentDidMount() {
    this.renderChart();
  }
  componentWillReceiveProps(){
    this.renderChart();
    // console.log(prevProps)
  }

 
  renderChart() {
    const { data } = this.props;
    console.log(data,'prop')
 
    const chartOptions = {
      chart: {
        type: 'column',
      },
      title: {
        text: 'Trips Percentage Comparison',
      },
      xAxis: {
        categories: data.map(obj => obj.vehicle_type),
        title: {
          text: 'Vehicle Type',
        },
      },
      yAxis: {
        title: {
          text: 'Percentage %',
        },
      },
      tooltip: {
        pointFormatter: function () {
          return `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${this.y}%</b><br/>`;
        }
      },
      series: [
        {
          name: 'Manual Trips',
          data: data.map(obj => obj.percent_demand_manual),
        },
        {
          name: 'System Trips',
          data: data.map(obj => obj.percent_demand_system),
        },
      ],
      credits:false
    };
 
    Highcharts.chart('chart-containerpercent', chartOptions);
  }
 
  render() {
    return <div id="chart-containerpercent" style={{ width: '100%', height: '400px' }}></div>;
  }
}
 
export default AdherencePercentBarChart;